import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule } from '@ngx-translate/core';
import { provideNgxMask } from 'ngx-mask';
import { MatCardModule } from '@angular/material/card';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPaginationModule } from 'ngx-pagination';
import { DialogExpirationModule } from '../core/components/dialog-expiration/dialog-expiration.module';
import { MaterialModule } from '../core/material/material.module';
import { ImageService } from '../core/services/image.service';
import { PaymentIconsService } from '../core/services/payment-icons.service';
import { AmountModule } from './components/amount/amount.module';
import { BranchsComponent } from './components/branchs/branchs.component';
import { CardComponent } from './components/card/card.component';
import { CollapsibleModule } from './components/collapsible/collapsible.module';
import { ConfirmarDialogModule } from './components/confirmar-dialog/confirmar-dialog.module';
import { CvuViewComponent } from './components/cvu-view/cvu-view.component';
import { DeleteAccountModule } from './components/delete-account/delete-account.module';
import { DialogAfipModule } from './components/dialog-afip/dialog-afip.module';
import { DialogCommerceModule } from './components/dialog-commerce/dialog-commerce.module';
import { ListTableComponent } from './components/list-table/list-table.component';
import { MenuItems } from './components/menu-items/menu-items';
import { MinimizedListComponent } from './components/minimized-list/minimized-list.component';
import { MovementsListComponent } from './components/movements-list/movements-list.component';
import { QRDialogModule } from './components/qr-dialog/qr-dialog.module';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { WarnFraudComponent } from './components/warn-fraud/warn-fraud.component';
import { YacareSpinnerModule } from './components/yacare-spinner/yacare-spinner.module';
import { CardRefreshDirective } from './directives/card-refresh.directive';
import { CardToggleDirective } from './directives/card-toggle.directive';
import { CurrencyValidatorDirective } from './directives/currency-validator.directive';
import { NumberStrictDirective } from './directives/number-strict.directive';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { ThrottledDirective } from './directives/throttled.directive';
import { DateFormatPipe } from './pipes/dateFormat.pipe';
import { ReadableDatePipe } from './pipes/readable-date.pipe';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { TermsAndConditionsDialogModule } from './components/terms-and-conditions-dialog/terms-and-conditions-dialog.module';
import { CustomCurrencyPipe } from './pipes/custom-currency.pipe';
import { MatDialogModule } from '@angular/material/dialog';
@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatToolbarModule,
    MatNativeDateModule,
    MatButtonModule,
    AmountModule,
    CollapsibleModule,
    DeleteAccountModule,
    DialogAfipModule,
    QRDialogModule,
    ConfirmarDialogModule,
    YacareSpinnerModule,
    MatProgressSpinnerModule,
    DialogCommerceModule,
    NgxPaginationModule,
    MaterialModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule.forChild({
      isolate: false
    }),
    MatDatepickerModule,
    NgxMatSelectSearchModule,
    DialogExpirationModule,
    TermsAndConditionsDialogModule,
    MatCardModule,
    MatDialogModule
  ],
  declarations: [
    CardRefreshDirective,
    CardToggleDirective,
    CardComponent,
    ListTableComponent,
    ReadableDatePipe,
    CurrencyValidatorDirective,
    NumberStrictDirective,
    OnlyNumberDirective,
    DateFormatPipe,
    SpinnerComponent,
    MovementsListComponent,
    CvuViewComponent,
    BranchsComponent,
    MinimizedListComponent,
    WarnFraudComponent,
    ThrottledDirective,
    BackButtonComponent,
    CustomCurrencyPipe
  ],
  exports: [
    CardRefreshDirective,
    CardToggleDirective,
    CardComponent,
    ListTableComponent,
    AmountModule,
    CurrencyValidatorDirective,
    NumberStrictDirective,
    OnlyNumberDirective,
    CollapsibleModule,
    DateFormatPipe,
    SpinnerComponent,
    MovementsListComponent,
    CvuViewComponent,
    BranchsComponent,
    MinimizedListComponent,
    WarnFraudComponent,
    ThrottledDirective,
    BackButtonComponent,
    CustomCurrencyPipe,
    MatDialogModule
  ],
  providers: [
    MenuItems,
    ReadableDatePipe,
    ImageService,
    ReadableDatePipe,
    DateFormatPipe,
    CustomCurrencyPipe,
    PaymentIconsService,
    provideNgxMask()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
